if (!customElements.get('lookbook-icon')) {
  customElements.define(
    'lookbook-icon',
    class LookbookIcon extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          cardContainer: '.lookbook-card',
          cardProduct: '.lookbook-card__product',
        };

        this._onMouseOverInit = this.init.bind(this);
        this._onTapToggle = this.onTapToggle.bind(this);
        this._onDocumentClick = this.onDocumentClick.bind(this);
        this._onKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        this.cardContainer = this.closest(this.selectors.cardContainer);
        this.cardProduct = this.querySelector(this.selectors.cardProduct);

        this.init();
        this.addEventListener('mouseover', this._onMouseOverInit);

        // Touch / tap devices: no :hover, so open/close product card with tap (matches desktop hover UX).
        this.useTapInteraction = !window.matchMedia('(hover: hover)').matches;
        if (this.useTapInteraction && this.cardProduct) {
          this.setAttribute('tabindex', '0');
          this.setAttribute('role', 'button');
          this.setAttribute('aria-expanded', 'false');
          this.addEventListener('click', this._onTapToggle);
          this.addEventListener('keydown', this._onKeydown);
          document.addEventListener('click', this._onDocumentClick);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('mouseover', this._onMouseOverInit);
        if (this.useTapInteraction) {
          this.removeEventListener('click', this._onTapToggle);
          this.removeEventListener('keydown', this._onKeydown);
          document.removeEventListener('click', this._onDocumentClick);
        }
      }

      onTapToggle(event) {
        if (event.target.closest('.lookbook-card__product')) {
          if (event.target.closest('a, button')) {
            return;
          }
          event.stopPropagation();
          return;
        }
        event.preventDefault();
        event.stopPropagation();

        const wasActive = this.classList.contains('is-active');
        if (this.cardContainer) {
          this.cardContainer.querySelectorAll('lookbook-icon.is-active').forEach((el) => {
            if (el !== this) {
              el.classList.remove('is-active');
              if (typeof el.syncAriaExpanded === 'function') {
                el.syncAriaExpanded();
              }
            }
          });
        }
        this.classList.toggle('is-active', !wasActive);
        this.syncAriaExpanded();
      }

      onDocumentClick(event) {
        if (this.contains(event.target)) {
          return;
        }
        this.classList.remove('is-active');
        this.syncAriaExpanded();
      }

      onKeydown(event) {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }
        event.preventDefault();
        const wasActive = this.classList.contains('is-active');
        if (this.cardContainer) {
          this.cardContainer.querySelectorAll('lookbook-icon.is-active').forEach((el) => {
            if (el !== this) {
              el.classList.remove('is-active');
              if (typeof el.syncAriaExpanded === 'function') {
                el.syncAriaExpanded();
              }
            }
          });
        }
        this.classList.toggle('is-active', !wasActive);
        this.syncAriaExpanded();
      }

      syncAriaExpanded() {
        if (this.hasAttribute('aria-expanded')) {
          this.setAttribute('aria-expanded', this.classList.contains('is-active') ? 'true' : 'false');
        }
      }

      init() {
        if (this.cardProduct && this.cardContainer) {
          this.cardContainerOffsetX = this.cardContainer.getBoundingClientRect().left;
          this.cardContainerOffsetY = this.cardContainer.getBoundingClientRect().top;

          this.offsetX = this.getBoundingClientRect().left - this.cardContainerOffsetX;
          this.offsetY = this.getBoundingClientRect().top - this.cardContainerOffsetY;

          this.cardProductWidth = this.cardProduct.clientWidth;
          this.cardProductHeight = this.cardProduct.clientHeight;
          this.cardContainerWidth = this.cardContainer.clientWidth;

          if (this.offsetX > this.cardProductWidth) {
            this.cardProduct.style.left = 'auto';
            if (this.cardContainerWidth - this.offsetY < 15) {
              this.cardProduct.style.right = 'calc(-100% + 2rem)';
            } else {
              this.cardProduct.style.right = '-100%';
            }
          } else {
            this.cardProduct.style.right = 'auto';
            if (this.cardContainerWidth - this.offsetX > this.cardProductWidth) {
              if (this.offsetX < 15) {
                this.cardProduct.style.left = 'calc(-100% + 2rem)';
              } else {
                this.cardProduct.style.left = '-100%';
              }
            } else {
              this.cardProduct.style.left = this.cardContainerWidth - this.cardProductWidth - this.offsetX + 'px';
            }
          }

          if (this.offsetY > this.cardProductHeight) {
            this.cardProduct.style.top = 'auto';
            this.cardProduct.style.bottom = '100%';
          } else {
            this.cardProduct.style.bottom = 'auto';
            this.cardProduct.style.top = '100%';
          }
        }
      }
    }
  );
}
